import { useCallback } from 'react';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import getIn from 'transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultCurrencyProps = {
  simplifyCurrency: true
};
const DefaultProperties = ({
  object,
  objectTypeDefinition,
  item,
  getIsUngated,
  currencyFormatOptions
}) => {
  const objectTypeId = objectTypeDefinition.objectTypeId;
  const objectId = `${object.objectId}`;
  const getAdditionalPropertyValue = useCallback(propertyName => getIn(['properties', propertyName, 'value'], object), [object]);
  const currencyProps = typeof currencyFormatOptions === 'function' ? currencyFormatOptions(item.value) : currencyFormatOptions || defaultCurrencyProps;
  return /*#__PURE__*/_jsx(FormattedPropertyV2, {
    objectTypeId: objectTypeId,
    objectId: objectId,
    property: item.definition,
    value: item.value,
    getAdditionalPropertyValue: getAdditionalPropertyValue,
    dateFormat: "L",
    dateTimeFormat: "L"
    // @ts-expect-error CDP new prop not yet merged
    ,
    getIsUngated: getIsUngated,
    currencyProps: currencyProps
  });
};
export default DefaultProperties;